import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { IdProps } from '../../../types/IdProps';
import AddSizePopup from '../Popups/SizeSet_popup_AddSize';

const SizeSet_tab_Sizes: React.FC<IdProps> = ({ id }) => {
    const [data, setData] = useState<[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleException, handleResult } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [id]);

    function getTableData() {
        DataService.get<[]>('api/v1/Sizes/BySizeSet/' + id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/sizes/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { title: 'ID', key: true, dataProp: 'id', dataType: 'number', visible: false },
        { title: 'Name', dataProp: 'name', filterInfo: { filterType: 'Textbox' } },
        { title: 'Sort order', dataProp: 'sortOrder', dataType: 'number', sort: 'asc' },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date' },
        { title: 'End date', dataProp: 'endDate', dataType: 'date' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.EditSize)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return <>
        <DataTable
            name='dtSizeSetSizes'
            colInfos={colInfos}
            tableData={data}
            navigateTitle='Size'
            navigateUrl='/plm/ItemSetup/Size/'
        />
        {showPopup && <AddSizePopup show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} sizeSetId={id} />}
    </>;
}
export default SizeSet_tab_Sizes;